import TextField from '@mui/material/TextField';

export default function ImageWordInput() {
    return <>
          <TextField id="outlined-basic" label="Explain image in one word" variant="outlined" />
</>
}